import React from 'react';
import { Switch, Route, useLocation } from 'react-router-dom';
import Home from './Home';
import Pictures from './Pictures';

const Main = () => {
  const location = useLocation();

  // We want Home (the map) to be rendered on ALL routes
  // The Pictures component will be rendered as an overlay if the route matches /pictures
  return (
    <main className="main-div">
      {/* Map is always rendered underneath */}
      <Route path="/" component={Home} />
      
      {/* Gallery overlay triggers if we are on /pictures */}
      <Route path="/pictures" render={(props) => (
        <Pictures {...props} isOpen={true} />
      )} />
    </main>
  );
};

export default Main;
